import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { trackCallClick } from "../lib/tracking";

/**
 * Bouton d'appel flottant premium.
 * - Se masque si le bandeau cookies mobile est ouvert (évite le chevauchement)
 * - Sur desktop il reste toujours visible (banner cookies ne le cache pas)
 */
export default function FloatingCallButton() {
  const number = "+33189707560";
  const display = "+33 1 89 70 75 60";
  const [bannerVisible, setBannerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);

    // Écoute la visibilité du bandeau cookies
    const onBanner = (e) => setBannerVisible(!!e.detail);
    window.addEventListener("mss-banner-visibility", onBanner);

    // État initial : si aucun consentement stocké, le bandeau va s'afficher
    try {
      if (!localStorage.getItem("mss_cookie_consent")) setBannerVisible(true);
    } catch (e) {}

    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("mss-banner-visibility", onBanner);
    };
  }, []);

  // Cache le bouton uniquement sur mobile quand le bandeau est visible
  if (isMobile && bannerVisible) return null;

  return (
    <a
      href={`tel:${number}`}
      onClick={() => trackCallClick("floating_button")}
      aria-label={`Nous appeler au ${display}`}
      className="fixed z-40 group bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 md:left-6 md:translate-x-0"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-emerald-500/50 animate-ping" aria-hidden="true"></span>
        <span className="absolute inset-0 rounded-full bg-emerald-500/30 blur-xl" aria-hidden="true"></span>

        <div className="relative flex items-center gap-3 bg-gradient-to-br from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-full shadow-2xl h-14 pl-2 pr-5 md:pr-6 transition-all duration-300 hover:scale-105 ring-4 ring-white/60">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm group-hover:rotate-12 transition-transform duration-300">
            <Phone className="w-5 h-5 fill-white" aria-hidden="true" />
          </div>
          <div className="flex flex-col leading-tight text-left">
            <span className="font-bold text-base whitespace-nowrap">{display}</span>
            <span className="text-[10px] opacity-90 whitespace-nowrap font-medium">Lun – Ven · 8h00 – 22h00</span>
          </div>
        </div>
      </div>
    </a>
  );
}
